import React from "react"

import { AppMileageAutocomplete } from "@components"
import { alertsDrawerData } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"
import { useAlertsDataInfo } from "Pages/ReportsAlerts/Alerts/Conditions/@hooks"
import { BACKEND_APIS } from "@constants"

export default function AlertsMileage() {

	const { dataInfo, setDataInfo } = useAlertsDataInfo(alertsDrawerData.peek().mileage)

	return <AppMileageAutocomplete
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/all/options/mileage`}
		value={dataInfo.value}
		onChange={e => setDataInfo(e.target.value, 'mileage')}
	/>
}